import { Directive } from 'vue';

type Handler = (event: Event) => void;

type ClickOutsideElement = HTMLElement & {
  _clickOutside?: {
    onClick: (event: Event) => void;
    onKeydown: (event: KeyboardEvent) => void;
    timer: number;
  };
};

// Calls the bound handler for a click outside the element, or for Escape —
// how row menus and popovers close. The listeners are attached on the next
// tick so the click that opened the element does not immediately close it.
const clickOutside: Directive<ClickOutsideElement, Handler> = {
  mounted(el, binding) {
    const onClick = (event: Event) => {
      if (!el.contains(event.target as Node)) binding.value(event);
    };
    const onKeydown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') binding.value(event);
    };
    const timer = window.setTimeout(() => {
      document.addEventListener('click', onClick);
      document.addEventListener('keydown', onKeydown);
    }, 0);

    el._clickOutside = { onClick, onKeydown, timer };
  },
  unmounted(el) {
    const state = el._clickOutside;
    if (!state) return;

    window.clearTimeout(state.timer);
    document.removeEventListener('click', state.onClick);
    document.removeEventListener('keydown', state.onKeydown);
    delete el._clickOutside;
  },
};

export default clickOutside;
